(function () {
  var url = window.DSD && window.DSD.trustpilot; if (!url) return;
  var RX = /★|darters gingen|beoordeel/i;
  function run() {
    var cand = Array.prototype.slice.call(document.querySelectorAll('.dsd .dsd-stats > div, .dsd .dsd-box, .dsd span, .dsd p'));
    var hits = cand.filter(function (el) {
      if (!RX.test(el.textContent || '')) return false;
      if (el.closest('a, button, label, .dsd-top, .dsd-drawer, [data-dsd-countdown]')) return false;
      if ((el.textContent || '').length > 160) return false;
      return true;
    });
    hits = hits.filter(function (el) { return !hits.some(function (o) { return o !== el && o.contains(el); }); });
    hits.forEach(function (el) {
      var a = document.createElement('a');
      a.href = url; a.target = '_blank'; a.rel = 'noopener';
      a.title = 'Bekijk onze reviews op Trustpilot';
      a.className = 'dsd-tp';
      el.parentNode.insertBefore(a, el); a.appendChild(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();